export default "__VITE_ASSET__1sPekwZ9__"